{
  "title": "Summon Lesser Demons",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a vial of blood from a humanoid killed within the past 24 hours)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You utter foul words, summoning demons from the chaos of the Abyss. Roll on the following table to determine what appears.",
    "d6",
    "Demons Summoned",
    "1-2",
    "Two demons of challenge rating 1 or lower",
    "3-4",
    "Four demons of challenge rating 1/2 or lower",
    "5-6",
    "Eight demons of challenge rating 1/4 or lower",
    "The DM chooses the demons, such as manes or dretches, and you choose the unoccupied spaces you can see within range where they appear. A summoned demon disappears when it drops to 0 hit points or when the spell ends.",
    "The demons are hostile to all creatures, including you. Roll initiative for the summoned demons as a group, which has its own turns. The demons pursue and attack the nearest non-demons to the best of their ability.",
    "As part of casting the spell, you can form a circle on the ground with the blood used as a material component. The circle is large enough to encompass your space. While the spell lasts, the summoned demons can't cross the circle or harm it, and they can't target anyone within it. Using the material component in this manner consumes it when the spell ends.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th or 7th level, you summon twice as many demons. If you cast it using a spell slot of 8th or 9th level, you summon three times as many demons."
  ],
  "spellLists": ["warlock", "wizard"]
}
